import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { useSelector } from 'react-redux';

import { useAuthenticated } from './services/hooks/';
import { AppEmployeeRoutes, AppClientRoutes, LandingRoutes } from './routes';
import ThemeProvider from './theme';
// components
import RtlLayout from './components-core/RtlLayout';
import { ChartStyle } from './components-core/chart';
import ScrollToTop from './components-core/ScrollToTop';
import { ProgressBarStyle } from './components-core/ProgressBar';
import NotistackProvider from './components-core/NotistackProvider';
import ThemeColorPresets from './components-core/ThemeColorPresets';
import MotionLazyContainer from './components-core/animate/MotionLazyContainer';
import AppGuestRoutes from './routes/AppGuestRoutes';

export const App = () => {
  const { token, group } = useSelector(state => state.app);
  const { isAuthenticated } = useAuthenticated();
  library.add(fas);


  React.useEffect(() => {
    useAuthenticated();
  }, [token]);

  return (
    <ThemeProvider>
      <ThemeColorPresets>
        <RtlLayout>
          <NotistackProvider>
            <MotionLazyContainer>
              <ProgressBarStyle />
              <ChartStyle />
              <ScrollToTop />
              <Routes>
                {isAuthenticated() ? (
                  group === 'employees' ? (
                    <Route path="*" element={<AppEmployeeRoutes />} />
                  ) : group === 'guests' ? (
                    <Route path="*" element={<AppGuestRoutes />} />) : (
                    <Route path="*" element={<AppClientRoutes />} />
                  )
                ) : (
                  <Route path="*" element={<LandingRoutes />} />
                )}
              </Routes>
            </MotionLazyContainer>
          </NotistackProvider>
        </RtlLayout>
      </ThemeColorPresets>
    </ThemeProvider>

  );
};
